import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapToggle = React.lazy(function () {
    return import('../../bootstrap-components/components/BTToggleSwitch');
});
var bootStrapToggle = function (props) {
    return (React.createElement(BootStrapToggle, __assign({}, props, { styleName: props.hasError ? 'danger' : props.styleName })));
};
var ToggleSwitch = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapToggle(props);
            break;
        default:
            componentToDisplay = bootStrapToggle(props);
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
ToggleSwitch.defaultProps = {
    styleName: 'primary',
    label: 'Toggle',
    ioTheme: themes[0],
    ioMode: 'light',
    active: true,
    size: 'sm',
};
export default React.memo(ToggleSwitch);
//# sourceMappingURL=ToggleSwitch.js.map